import React, {Fragment} from "react";
import PropTypes from "prop-types";

SituatieInfo.propTypes = {
    onRemoveRow: PropTypes.func.isRequired,
    currentRow: PropTypes.number.isRequired,
}

export default function SituatieInfo(props) {
    return <div className="phone-page-middle">
        <div className="phone-pick-title">
            {props.currentRow < 1 ? <>
                Het kan zijn dat uw sitatie verschilt per raam of gebouw.<br/>
                <br/>
                Vul nu één situatie in. Achteraf kunt u dit nogmaals invullen voor de overige situaties.<br/>
            </> : <>
                Dit is het beginscherm van situatie {props.currentRow + 1}.<br/><br/>
                Een situatie te veel aangemaakt?<br/>
                <a onClick={props.onRemoveRow}>Klik hier als u situatie {props.currentRow + 1} wil verwijderen.</a>
            </>}
        </div>
    </div>;
}